// extracted by mini-css-extract-plugin
export default {"loading":"uAKM6cguvGSJUjqki0Gk"};